var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('excel-editor',{staticClass:"prodTbl",attrs:{"head":_vm.tHead},model:{value:(_vm.product),callback:function ($$v) {_vm.product=$$v},expression:"product"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }